var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3951",
    "data-name": "Group 3951",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.564,
    height: 15.549,
    viewBox: "0 0 15.564 15.549",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1228",
    "data-name": "Rectangle 1228",
    width: 15.564,
    height: 15.549,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3950",
    "data-name": "Group 3950",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M6.8,16.793H4.3a4.234,4.234,0,0,1-4.252-3.6A4.3,4.3,0,0,1,0,12.505Q0,9.986,0,7.467A4.233,4.233,0,0,1,3.6,3.216a3.905,3.905,0,0,1,.618-.047q1.6-.006,3.193,0a.569.569,0,0,1,.555.365.52.52,0,0,1-.15.611.824.824,0,0,1-.436.152c-1.035.013-2.069,0-3.1.007A3.11,3.11,0,0,0,1.138,7.42q-.005,2.555,0,5.109a3.1,3.1,0,0,0,3.131,3.128q2.545,0,5.091,0a3.1,3.1,0,0,0,3.132-3.128c0-1.052,0-2.105,0-3.157a.54.54,0,0,1,.341-.533.5.5,0,0,1,.6.107.681.681,0,0,1,.182.4c.013,1.141.039,2.283,0,3.423A4.22,4.22,0,0,1,9.483,16.79c-.893.013-1.786,0-2.678,0Z",
    transform: "translate(0 -1.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M19.212,1.81a1.9,1.9,0,0,1-.6,1.36c-.783.781-1.561,1.566-2.341,2.349C15.052,6.746,13.831,7.976,12.6,9.195a1.048,1.048,0,0,1-.466.259c-.7.173-1.4.322-2.107.475a.59.59,0,0,1-.747-.742c.158-.721.31-1.443.482-2.16a.906.906,0,0,1,.226-.408Q13,3.591,16.033.576A1.8,1.8,0,0,1,17.906.085a1.728,1.728,0,0,1,1.263,1.374,3.375,3.375,0,0,1,.043.352M10.564,8.632c.375-.084.727-.153,1.072-.246a.809.809,0,0,0,.342-.19c.579-.566,1.149-1.142,1.721-1.715q2.045-2.044,4.089-4.088a.783.783,0,0,0,.265-.485.66.66,0,0,0-.374-.684.72.72,0,0,0-.83.161q-2.962,2.944-5.919,5.894a.391.391,0,0,0-.105.177c-.09.379-.17.76-.262,1.175",
    transform: "translate(-3.647 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessageIcon);
export default __webpack_public_path__ + "static/media/NewMessageIcon.e5b216eea3ac2f5f23e6547e99f14ad3.svg";
export { ForwardRef as ReactComponent };